import React from 'react'
import Layout from '../components/layout'
//import { Link } from 'gatsby'
import imgKilijan from '../images/kilijan.jpg'
import imgLilli from '../images/lilli.jpg'
import imgJulie from '../images/julie.jpg'
import imgLeonie from '../images/leonie.jpg'
import imgAdrian from '../images/adrian.jpg'
import imgPaulina from '../images/paulina.jpg'
import imgDiana from '../images/diana.jpg'
import imgJolina from '../images/jolina.jpg'
import imgSima from '../images/sima.jpg'
import imgLiz from '../images/liz.jpg'
import imgKarolina from '../images/karolina.jpg'
import ExternalLink from '../components/ExternalLink'
/* import imgKulturwerke from '../images/kulturwerke-padded.jpeg' */

import SEO from "../components/seo"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons'

import { youtubeChannelUrl, instagramProfileUrl, tiktokProfileUrl } from '../utils'

const LinerCard = ({ img, name, children }) => (
  <div className='media col-12 lineup rounded shadow'>
    <img src={img} alt={name} width='120' height='120'  className='rounded-circle'/>
    <div className='media-body'>
      <h5 className='mt-0'>{name}</h5>
      {children}
    </div>
  </div>
)

const YoutubeLink = ({ channelId, channelUrl, children }) => (
  <>
    <FontAwesomeIcon icon={faYoutube} className='text-white mr-2'/>
    <ExternalLink href={channelUrl || youtubeChannelUrl(channelId)}>
      {children}
    </ExternalLink>
  </>
)

const InstagramLink = ({ profileId, children }) => (
  <>
    <FontAwesomeIcon icon={faInstagram} className='text-white mr-2'/>
    <ExternalLink href={instagramProfileUrl(profileId)}>
      {children || `@${profileId}`}
    </ExternalLink>
  </>
)

const TiktokLink = ({ profileId, children }) => (
  <>
    <FontAwesomeIcon icon={faTiktok} className='text-white mr-2'/>
    <ExternalLink href={tiktokProfileUrl(profileId)}>
      {children || `@${profileId}`}
    </ExternalLink>
  </>
)

const Lineup = () => {
  return(
    <Layout pageInfo={{pageName: 'lineup'}} >
      <SEO title="Lineup" keywords={[`schueleraustausch`, `meetup`, `Line-up`]} />
      <section className='masthead min-vh-100'>
        <div className="text-left text-white">
          <div className="masthead-content">
            <div className="container">
              <div className='row'>
                <div className='col-md-6'>
                  <h1>Das X-CHANGE Lineup 2021</h1>
                  <p className='lead'>
                    Diese X-CHANGE-Botschafter*innen werden am 26. September beim Virtual X-CHANGE Meetup dabei sein.
                  </p>
                  <p>
                    Klicke jetzt durch die YouTube- und Instagram Profile der Teilnehmer*innen
                    und überlege dir Fragen, die du ihnen zum Auslandsjahr stellen möchtest.
                  </p>
                  <p>
                    Wir werden versuchen deine Fragen beim Virtual X-CHANGE Meetup live zu beantworten.
                  </p>
                  <p>
                    Wir freuen uns auf dich!
                  </p>
                </div>
                <div className='col-md-6'>
                  <div className='row'>
                    <LinerCard img={imgKilijan} name='Kilian'>
                      <p>
                        <a href='https://www.schueleraustausch.net/ratgeber/x-change-botschafter-kilijan-usa-texas'>
                          Kilians Profil
                        </a>
                        <br/>
                        <YoutubeLink channelId='UCYax_Yff_x5MTLAkn4j46PA'>Kilijans Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='kilijannn'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgJulie} name='Julie'>
                      <p>
                        <TiktokLink profileId='julieerc_'/>
                        <br/>
                        <InstagramLink profileId='julieerc_'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgLilli} name='Lilli'>
                      <p>
                        <a href='https://www.schueleraustausch.net/ratgeber/x-change-botschafterin-lilli-usa-michigan'>
                          Lillis Profil
                        </a>
                        <br/>
                        <YoutubeLink channelId='UCDxv5EGRV1EbSN9BF0fg9Ew'>Lillis Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='iamlilliii'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgLeonie} name='Leonie'>
                      <p>
                        <a href='https://www.schueleraustausch.net/ratgeber/x-change-botschafterin-leonie-usa-florida'>
                          Leonies Profil
                        </a>
                        <br/>
                        <YoutubeLink channelId='UC1_chWUG0YkeY5v7gHmQenQ'>Leonies Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='leoniesliife'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgDiana} name='Diana'>
                      <p>
                        <YoutubeLink channelId='UCVuys8EmqjwR6ktXWNOLvyA'>Dianas Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='dianadaytona_'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgKarolina} name='Karolina'>
                      <p>
                        <YoutubeLink channelUrl='https://www.youtube.com/c/KarolinasLife/featured'>Karolinas Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='karoxannax'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgJolina} name='Jolina'>
                      <p>
                        <a href="https://www.schueleraustausch.net/ratgeber/x-change-botschafterin-jolina-australien-adelaide">
                          Jolinas Profil
                        </a>
                        <br />
                        <YoutubeLink channelId='UCUYuZNXWs-otH4hIbmse0CA'>Jolinas Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='jolinainaustralia'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgAdrian} name='Adrian'>
                      <p>
                        <InstagramLink profileId='adrian.scnl'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgPaulina} name='Paulina'>
                      <p>
                        <a href="https://www.schueleraustausch.net/ratgeber/x-change-botschafterin-paulina-usa-south-carolina">
                          Paulinas Profil
                        </a>
                        <br/>
                        <YoutubeLink channelId='UCCTMCLSVkv-iucsE7tl6RaA'>Paulinas Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='paulinaclaire'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgLiz} name='Liz'>
                      <p>
                        <YoutubeLink channelId='UCRwaAmm0ijxQjaK0TEUUcHw'>Liz Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='itslizkatherine'/>
                      </p>
                    </LinerCard>
                    <LinerCard img={imgSima} name='Sima'>
                      <p>
                        <YoutubeLink channelId='UC9a2P9wZfzTwUaKYrXiysug'>Simas Channel</YoutubeLink>
                        <br/>
                        <InstagramLink profileId='simaaysu'/>
                      </p>
                    </LinerCard>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-circle-1 bg-circle"></div>
          <div className="bg-circle-2 bg-circle"></div>
          <div className="bg-circle-3 bg-circle"></div>
          <div className="bg-circle-4 bg-circle"></div>
        </div>
      </section>
    </Layout>
  )
}

export default Lineup
